module.exports = __webpack_public_path__ + "img/trash.dee4d505.svg";